// This file is auto-generated by @hey-api/openapi-ts

export type LoginUserDto = {
  email: string;
  password: string;
};

export enum Subject {
  USER = 'User',
  ORGANIZATION = 'Organization',
  ORGANIZATION_USER = 'OrganizationUser',
  LOCATION = 'Location',
  NETWORK = 'Network',
  ADMIN_LEVEL = 'AdminLevel',
  EMPLOYEE = 'Employee',
  INDICATOR_PROCESS = 'IndicatorProcess',
  INDICATOR_RELATION = 'IndicatorRelation',
  INDICATOR_ROUTING_CONFIGURATION = 'IndicatorRoutingConfiguration',
}

/**
 * Nutzerstatus
 */
export enum UserStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  INVITED = 'INVITED',
}

/**
 * Globale Nutzerrolle
 */
export enum UserRole {
  TRAFFICON_ADMIN = 'TRAFFICON_ADMIN',
  IVM_ADMIN = 'IVM_ADMIN',
  IVM_USER = 'IVM_USER',
  ORGANIZATION_USER = 'ORGANIZATION_USER',
}

/**
 * Nutzerrolle innerhalb des Arbeitgebers
 */
export enum OrganizationUserRole {
  IVM_INTERNAL = 'IVM_INTERNAL',
  IVM_CONSULTANT = 'IVM_CONSULTANT',
  ORGANIZATION_MOBILITY_AGENT_WRITE = 'ORGANIZATION_MOBILITY_AGENT_WRITE',
  ORGANIZATION_MOBILITY_AGENT_READ = 'ORGANIZATION_MOBILITY_AGENT_READ',
  ORGANIZATION_DECISION_MAKER = 'ORGANIZATION_DECISION_MAKER',
}

/**
 * Branche
 */
export enum Sector {
  MANUFACTURING_INDUSTRY = 'MANUFACTURING_INDUSTRY',
  ENERGY_WATER_SUPPLY = 'ENERGY_WATER_SUPPLY',
  BUILDING_INDUSTRY = 'BUILDING_INDUSTRY',
  TRADE_HOSPITALITY_INDUSTRY = 'TRADE_HOSPITALITY_INDUSTRY',
  TRANSPORT = 'TRANSPORT',
  INFORMATION_COMMUNICATION = 'INFORMATION_COMMUNICATION',
  FINANCE_INSURANCE = 'FINANCE_INSURANCE',
  PROPERTY_HOUSING = 'PROPERTY_HOUSING',
  SCIENCE = 'SCIENCE',
  ECONOMY_SERVICE = 'ECONOMY_SERVICE',
  OTHER_SERVICES = 'OTHER_SERVICES',
  CIVIL_SERVICE = 'CIVIL_SERVICE',
  HEALTH_SOCIAL_SERVICE = 'HEALTH_SOCIAL_SERVICE',
  AGRICULTURE_FORESTRY_FISHERY = 'AGRICULTURE_FORESTRY_FISHERY',
  MINING = 'MINING',
  OTHER = 'OTHER',
}

/**
 * Beratungsprozess Status
 */
export enum ConsultingStatus {
  CONTACT_REQUEST = 'CONTACT_REQUEST',
  LETTER_OF_INTENT = 'LETTER_OF_INTENT',
  CONSULTING = 'CONSULTING',
  MOBILITY_PLAN = 'MOBILITY_PLAN',
  AUDIT = 'AUDIT',
  RE_AUDIT = 'RE_AUDIT',
  COMPLETED = 'COMPLETED',
}

/**
 * Ausfüllfortschritt
 */
export enum FillStatus {
  EMPTY = 'EMPTY',
  PARTIAL = 'PARTIAL',
  COMPLETE = 'COMPLETE',
}

export enum CommuteType {
  HOME_OFFICE = 'HOME_OFFICE',
  WALK = 'WALK',
  BIKE = 'BIKE',
  BIKE_AND_RIDE = 'BIKE_AND_RIDE',
  PARK_AND_RIDE = 'PARK_AND_RIDE',
  PUBLIC_TRANSPORT = 'PUBLIC_TRANSPORT',
  CAR_POOL = 'CAR_POOL',
  CAR_MOTORCYCLE = 'CAR_MOTORCYCLE',
  CAR_ELECTRIC = 'CAR_ELECTRIC',
  LONG_DISTANCE_TRANSPORT = 'LONG_DISTANCE_TRANSPORT',
  SCOOTER = 'SCOOTER',
  MOPED = 'MOPED',
  E_SCOOTER = 'E_SCOOTER',
  PARENT_TAXI = 'PARENT_TAXI',
}

export enum ShareAnalysisPeriod {
  ALL = 'ALL',
  TODAY = 'TODAY',
  LAST_7_DAYS = 'LAST_7_DAYS',
  LAST_30_DAYS = 'LAST_30_DAYS',
}

/**
 * Style für Monitoring
 */
export enum MonitoringStyle {
  BMM = 'BMM',
  SMM = 'SMM',
  IVM = 'IVM',
}

export enum LocationProfileStatus {
  EDITABLE = 'EDITABLE',
  SUBMITTED = 'SUBMITTED',
  CONFIRMED = 'CONFIRMED',
}

/**
 * Räumlicher Ebenentyp
 */
export enum AdminLevelType {
  GOVERNMENT_DISTRICT = 'GOVERNMENT_DISTRICT',
  COUNTY = 'COUNTY',
  FREE_CITY = 'FREE_CITY',
  MUNICIPALITY = 'MUNICIPALITY',
  CITY = 'CITY',
  MUNICIPALITY_FREE_AREA = 'MUNICIPALITY_FREE_AREA',
}

export type AdminLevel = {
  __caslSubjectType__: Subject;
  /**
   * Räumlicher Ebenentyp
   */
  type: AdminLevelType;
  name: string;
  parent?: AdminLevel;
  children?: Array<AdminLevel>;
  locations?: Array<Location>;
  publication: boolean;
  id: string;
  createdAt: string;
  updatedAt: string;
};

/**
 * Netzwerkkategorie
 */
export enum NetworkCategory {
  TRANSPORT_ASSOCIATION = 'TRANSPORT_ASSOCIATION',
  IHK_DISTRICT = 'IHK_DISTRICT',
  SHAREHOLDER_DISTRICT = 'SHAREHOLDER_DISTRICT',
  REGION = 'REGION',
  BUSINESS_PARK = 'BUSINESS_PARK',
  COOPERATION = 'COOPERATION',
  QUARTER = 'QUARTER',
  ORGANIZATION_TYPE = 'ORGANIZATION_TYPE',
}

export type Network = {
  __caslSubjectType__: Subject;
  /**
   * Netzwerkkategorie
   */
  category: NetworkCategory;
  name: string;
  locations?: Array<Location>;
  id: string;
  createdAt: string;
  updatedAt: string;
};

/**
 * Art des Gebäudes / Grundstücks
 */
export enum BuildingType {
  RENTAL_PROPERTY = 'RENTAL_PROPERTY',
  OWN_PROPERTY = 'OWN_PROPERTY',
}

export type GenderDistributionDto = {
  /**
   * Weiblich
   */
  female?: number | null;
  /**
   * Männlich
   */
  male?: number | null;
  /**
   * Divers, nicht eindeutig männlich oder weiblich
   */
  nonBinary?: number | null;
};

export type AgeDistributionDto = {
  /**
   * Unter 18 Jahre
   */
  younger18?: number | null;
  /**
   * 18 - 25 Jahre
   */
  from18to25?: number | null;
  /**
   * 26 - 35 Jahre
   */
  from26to35?: number | null;
  /**
   * 36 - 45 Jahre
   */
  from36to45?: number | null;
  /**
   * 46 - 55 Jahre
   */
  from46to55?: number | null;
  /**
   * Über 55 Jahre
   */
  older55?: number | null;
};

export type WorkingModelDto = {
  /**
   * Beschäftigte in Wechselschicht
   */
  altShift?: number | null;
  /**
   * Beschäftigte in versetzter Tagschicht
   */
  offsetDayShift?: number | null;
  /**
   * Beschäftigte in Teilzeit (einzelne Tage)
   */
  partTimeDays?: number | null;
  /**
   * Beschäftigte in Teilzeit (halbtags)
   */
  partTimeHalfDays?: number | null;
  /**
   * Beschäftigte mit normale Arbeitszeiten und Gleitzeit
   */
  flexTime?: number | null;
  /**
   * Beschäftigte mit normale Arbeitszeiten ohne Gleitzeit
   */
  withoutFlexTime?: number | null;
  /**
   * Beschäftigte mit sonstigen Arbeitszeitmodell
   */
  other?: number | null;
};

export type CarDriveTypeDto = {
  /**
   * Diesel
   */
  diesel?: number | null;
  /**
   * Benzin
   */
  petrol?: number | null;
  /**
   * Gas
   */
  naturalGas?: number | null;
  /**
   * Hybrid
   */
  hybrid?: number | null;
  /**
   * Elektrisch
   */
  electric?: number | null;
};

export type CarUsageDto = {
  /**
   * Mit Privatnutzung
   */
  withPrivateUsage?: CarDriveTypeDto | null;
  /**
   * Ohne Privatnutzung
   */
  withoutPrivateUsage?: CarDriveTypeDto | null;
};

export type OrganizationCarsDto = {
  /**
   * Poolfahrzeuge
   */
  pool: CarUsageDto | null;
  /**
   * Abteilungsfahrzeuge
   */
  department?: CarUsageDto | null;
  /**
   * Personenbezogene Fahrzeuge
   */
  personal?: CarUsageDto | null;
};

export type TwoWheelersDto = {
  /**
   * Insgesamt
   */
  total?: number | null;
  /**
   * Elektrisch
   */
  electric?: number | null;
  /**
   * Leasingrad
   */
  leasing?: number | null;
};

export type OrganizationTwoWheelersDto = {
  /**
   * Fahrräder
   */
  bicycles?: TwoWheelersDto | null;
  /**
   * Lastenräder
   */
  cargoBikes?: TwoWheelersDto | null;
  /**
   * Roller
   */
  scooters?: TwoWheelersDto | null;
};

/**
 * Art der Organisation
 */
export enum BusinessTripOrganizationType {
  CENTRAL = 'CENTRAL',
  DECENTRAL = 'DECENTRAL',
  OTHER = 'OTHER',
}

export type BusinessTripOrganizationDto = {
  /**
   * Art der Organisation
   */
  type?: BusinessTripOrganizationType | null;
  /**
   * Sonstiges
   */
  other?: string | null;
};

/**
 * Mit welchem Verkehrsmittel werden Dienst-/Geschäftsreisen i.d.R. unternommen? Verkehrsmittel
 */
export enum BusinessTripTransportationType {
  PRIVATE_CAR = 'PRIVATE_CAR',
  ORGANIZATION_CAR = 'ORGANIZATION_CAR',
  POOL_CAR = 'POOL_CAR',
  PUBLIC_TRANSPORT = 'PUBLIC_TRANSPORT',
  AIRCRAFT = 'AIRCRAFT',
  CAR_SHARING = 'CAR_SHARING',
  RENTAL_CAR = 'RENTAL_CAR',
  BICYCLE = 'BICYCLE',
  SERVICE_BICYCLE = 'SERVICE_BICYCLE',
  BICYCLE_RENT = 'BICYCLE_RENT',
  OTHER = 'OTHER',
}

/**
 * Duschen, Umkleidemöglichkeiten und/oder Spinde für Radfahrer
 */
export enum BicycleChangingType {
  SHOWER = 'SHOWER',
  CHANGING_ROOM = 'CHANGING_ROOM',
  LOCKER = 'LOCKER',
}

/**
 * Verbesserung der Erreichbarkeit des Betriebs für Beschäftigte
 */
export enum SurveyImportance {
  VERY_IMPORTANT = 'VERY_IMPORTANT',
  FAIRLY_IMPORTANT = 'FAIRLY_IMPORTANT',
  LESS_IMPORTANT = 'LESS_IMPORTANT',
  NOT_IMPORTANT = 'NOT_IMPORTANT',
  NOT_SPECIFIED = 'NOT_SPECIFIED',
}

/**
 * Welche der folgenden Maßnahmen und Managementinstrumente sind bei Ihnen im Einsatz oder geplant? Maßnahmen
 */
export enum ManagementInstrumentType {
  OEKO_AUDIT = 'OEKO_AUDIT',
  UMWELTMANAGEMENT_ISO14001 = 'UMWELTMANAGEMENT_ISO14001',
  OEKO_PROFIT = 'OEKO_PROFIT',
  UMWELTBERICHTERSTATTUNG = 'UMWELTBERICHTERSTATTUNG',
  NACHHALTIGKEITSBERICHTERSTATTUNG = 'NACHHALTIGKEITSBERICHTERSTATTUNG',
  UMWELTKOSTENRECHNUNG = 'UMWELTKOSTENRECHNUNG',
  VERWALTUNGSMODERNISIERUNG = 'VERWALTUNGSMODERNISIERUNG',
  QUALITAETSMANAGEMENT_ISO9001 = 'QUALITAETSMANAGEMENT_ISO9001',
  BETRIEBLICHE_GESUNDHEITSFOERDERUNG = 'BETRIEBLICHE_GESUNDHEITSFOERDERUNG',
  SICHERHEIT_ARBEITSSCHUTZMANAGEMENT = 'SICHERHEIT_ARBEITSSCHUTZMANAGEMENT',
  OTHER = 'OTHER',
}

export type YesNoIfYesDescribeDto = {
  /**
   * Ja / Nein
   */
  bool?: boolean | null;
  /**
   * Wenn ja? Beschreibe
   */
  description?: string | null;
};

export enum PublicTransportInformationType {
  FAHRPLANAUSHANG = 'FAHRPLANAUSHANG',
  ZUGANG_INTRANET_FAHRPLAN = 'ZUGANG_INTRANET_FAHRPLAN',
  OTHER = 'OTHER',
}

export enum PublicTransportFundingType {
  JOB_TICKET = 'JOB_TICKET',
  SUBSIDY_50 = 'SUBSIDY_50',
  SUBSIDY_20_TO_50 = 'SUBSIDY_20_TO_50',
  OTHER = 'OTHER',
}

export enum CarFinancialFundingType {
  COMPANY_CAR = 'COMPANY_CAR',
  FREE_PARKING = 'FREE_PARKING',
  OTHER = 'OTHER',
}

/**
 * Bestehen Anreize und Informationen zum energiesparenden und sicheren Autofahren?
 */
export enum SafeAndEcoDrivingIncentive {
  PAPER_HINT = 'PAPER_HINT',
  COURSE_OR_SIMULATOR = 'COURSE_OR_SIMULATOR',
  NONE = 'NONE',
}

export enum BicycleIncentiveType {
  FINANCIAL = 'FINANCIAL',
  SERVICES = 'SERVICES',
  LEASING = 'LEASING',
  OTHER = 'OTHER',
}

export enum CarSharingPromotionType {
  SHARING_SITE = 'SHARING_SITE',
  OTHER = 'OTHER',
}

/**
 * Entfernung zum nächstgelegenen Bahnhof
 */
export enum DistanceType {
  LESS_THAN_250 = 'LESS_THAN_250',
  BETWEEN_250_AND_500 = 'BETWEEN_250_AND_500',
  BETWEEN_501_AND_750 = 'BETWEEN_501_AND_750',
  BETWEEN_751_AND_1000 = 'BETWEEN_751_AND_1000',
  BETWEEN_1001_AND_1500 = 'BETWEEN_1001_AND_1500',
  MORE_THAN_1500 = 'MORE_THAN_1500',
}

/**
 * Qualität der Fahrradabstellanlagen am Bahnhof
 */
export enum GoodMediumBad {
  GOOD = 'GOOD',
  MEDIUM = 'MEDIUM',
  BAD = 'BAD',
}

/**
 * Lage des Standortes
 */
export enum LocationAreaType {
  URBAN = 'URBAN',
  SUBURBAN = 'SUBURBAN',
  COUNTRYSIDE = 'COUNTRYSIDE',
}

/**
 * Welche Nutzung befindet sich im Umfeld des Betriebes?
 */
export enum NeighbourhoodUsage {
  RESIDENTIAL_USE = 'RESIDENTIAL_USE',
  INDUSTRY = 'INDUSTRY',
  MIXED_USE = 'MIXED_USE',
}

/**
 * Wird der Parkraum im öffentlichen Raum bewirtschaftet?
 */
export enum YesNoPartly {
  YES = 'YES',
  NO = 'NO',
  PARTLY = 'PARTLY',
}

/**
 * Parkplatzsituation im öffentlichen Raum
 */
export enum LoadFactor {
  LOW_LOAD = 'LOW_LOAD',
  WELL_LOADED = 'WELL_LOADED',
  OVERLOADED = 'OVERLOADED',
}

/**
 * Radinfrastruktur im Umfeld des Standortes
 */
export enum NeighbourhoodBicycleInfrastructure {
  BICYCLE_INFRASTRUCTURE = 'BICYCLE_INFRASTRUCTURE',
  LOW_TRAFFIC = 'LOW_TRAFFIC',
  HIGH_TRAFFIC = 'HIGH_TRAFFIC',
}

export type QualityWithDescriptionDto = {
  /**
   * Qualität
   */
  quality?: GoodMediumBad | null;
  /**
   * Beschreibung
   */
  description?: string | null;
};

export enum PedestrianPathType {
  ILLUMINATED = 'ILLUMINATED',
  PAVED_ROAD = 'PAVED_ROAD',
  OTHER = 'OTHER',
}

/**
 * Fahrzeit (ÖV) vom Betrieb in die Innenstadt des nächsten Mittelzentrums (bzw. Oberzentrums) (sollten mehrere Haltestellen im Umkreis von 500 m am Betrieb liegen, wählen Sie die aus, die am besten bedient wird)
 */
export enum DurationType {
  LESS_THAN_5_MIN = 'LESS_THAN_5_MIN',
  BETWEEN_6_AND_10_MIN = 'BETWEEN_6_AND_10_MIN',
  BETWEEN_11_AND_20_MIN = 'BETWEEN_11_AND_20_MIN',
  BETWEEN_21_AND_40_MIN = 'BETWEEN_21_AND_40_MIN',
  BETWEEN_41_AND_60_MIN = 'BETWEEN_41_AND_60_MIN',
  MORE_THAN_60_MIN = 'MORE_THAN_60_MIN',
}

/**
 * Anzahl der Ankünfte der öffentlichen Verkehrsmittel an der Haltestelle werktags zwischen 7-9 Uhr (bzw. zu den für die Beschäftigten relevanten Zeiten) (sollten mehrere Haltestellen im Umkreis von 500 m am Betrieb liegen, wählen Sie die aus, die am besten bedient wird)
 */
export enum ArrivalCount {
  BETWEEN_0_AND_1 = 'BETWEEN_0_AND_1',
  BETWEEN_2_AND_5 = 'BETWEEN_2_AND_5',
  BETWEEN_6_AND_12 = 'BETWEEN_6_AND_12',
  BETWEEN_13_AND_24 = 'BETWEEN_13_AND_24',
  BETWEEN_25_AND_48 = 'BETWEEN_25_AND_48',
  MORE_THAN_48 = 'MORE_THAN_48',
}

/**
 * Lage des Parkplatzes
 */
export enum ParkingLocation {
  PARKING_LOT = 'PARKING_LOT',
  UNDERGROUND_PARKING = 'UNDERGROUND_PARKING',
  PARKING_GARAGE = 'PARKING_GARAGE',
}

/**
 * Stellplatzanlage gebührenpflichtig
 */
export enum ParkingFeeType {
  NO = 'NO',
  YES = 'YES',
  PARTLY = 'PARTLY',
  PAY_AS_YOU_USE = 'PAY_AS_YOU_USE',
  FLAT_RATE = 'FLAT_RATE',
}

/**
 * Gebühr Zeitraum
 */
export enum ParkingFeePeriod {
  DAY = 'DAY',
  WEEK = 'WEEK',
  MONTH = 'MONTH',
  YEAR = 'YEAR',
}

export type ParkingCarsDto = {
  /**
   * Bezeichnung der Anlage
   */
  name?: string | null;
  /**
   * Firmeneigener Stellplatz
   */
  proprietary?: boolean | null;
  /**
   * Anzahl der Stellplätze
   */
  size?: number | null;
  /**
   * Lage des Parkplatzes
   */
  location?: ParkingLocation | null;
  /**
   * Nutzungsberechtigung erforderlich
   */
  usageAuthorization?: YesNoPartly | null;
  /**
   * Stellplatzanlage gebührenpflichtig
   */
  parkingFeeType?: ParkingFeeType | null;
  /**
   * Höhe der Gebühr
   */
  parkingFeeAmount?: number | null;
  /**
   * Gebühr Zeitraum
   */
  parkingFeePeriod?: ParkingFeePeriod | null;
  /**
   * Entfernung vom Parkplatz zum (Betriebs-)Eingang in Meter
   */
  distance?: number | null;
  /**
   * Anzahl Stellplätze mit Ladepunkten für E-Fahrzeuge für Poolwagen/reine Dienstfahrzeuge
   */
  chargingPointsPoolCar?: number | null;
  /**
   * Anzahl Stellplätze mit Ladepunkten für E-Fahrzeuge für Privatnutzung durch Beschäftigte
   */
  chargingPointsPrivate?: number | null;
  /**
   * Wird die jeweils benötigte Ladeleistung durch ein Lastmanagement optimiert?
   */
  chargingPointLoadOptimization?: YesNoPartly | null;
  /**
   * Ist das Laden privater Pkw für die Beschäftigten kostenpflichtig?
   */
  chargingPayable?: YesNoPartly | null;
};

/**
 * Kriterien zur Vergabe von Parkberechtigungen
 */
export enum ParkingPermitAllocationType {
  HIERARCHY = 'HIERARCHY',
  NONE = 'NONE',
  DISTANCE = 'DISTANCE',
  SPECIAL_NEED = 'SPECIAL_NEED',
  OTHER = 'OTHER',
}

export type ParkingPermitAllocationDto = {
  /**
   * Kriterien zur Vergabe von Parkberechtigungen
   */
  type?: ParkingPermitAllocationType | null;
  /**
   * Sonstiges
   */
  other?: string | null;
};

/**
 * Standort Typ
 */
export enum BicycleParkingLocationType {
  OUTDOOR = 'OUTDOOR',
  BUILDING = 'BUILDING',
  OTHER = 'OTHER',
}

export type BicycleParkingLocation = {
  /**
   * Standort Typ
   */
  type?: BicycleParkingLocationType | null;
  /**
   * Sonstiges
   */
  other?: string | null;
};

export type ParkingBicyclesDto = {
  /**
   * Bezeichnung der Anlage
   */
  name?: string | null;
  /**
   * Anzahl der Stellplätze gesamt
   */
  size?: number | null;
  /**
   * Anzahl der Stellplätze Felgenklemmer
   */
  rimSqueezers?: number | null;
  /**
   * Anzahl der Stellplätze Bügel
   */
  racks?: number | null;
  /**
   * Standort
   */
  location?: BicycleParkingLocation | null;
  /**
   * Eingangsnah
   */
  closeToEntrance?: YesNoPartly | null;
  /**
   * Beleuchtet
   */
  illuminated?: YesNoPartly | null;
  /**
   * Gut einsehbar
   */
  goodVisible?: YesNoPartly | null;
  /**
   * Auslastung Fahrradabstellanlage
   */
  loadFactor?: LoadFactor | null;
  /**
   * Lademöglichkeiten für Pedelecs/ E-Bikes bei den Fahrradabstellplätzen
   */
  chargingPointAvailable?: boolean | null;
  /**
   * Lademöglichkeiten der Akkus am Arbeitsplatz
   */
  chargingAtWorkplace?: boolean | null;
};

export type LocationProfile = {
  __caslSubjectType__: Subject;
  /**
   * Standort
   */
  location?: Location;
  /**
   * Art des Gebäudes / Grundstücks
   */
  buildingType: BuildingType | null;
  /**
   * Geschlechterverteilung der Beschäftigten
   */
  genderDistribution: GenderDistributionDto | null;
  /**
   * Altersverteilung der Beschäftigten
   */
  ageDistribution: AgeDistributionDto | null;
  /**
   * Anzahl der Kunden/Besucher je Woche
   */
  customersPerWeek: number | null;
  /**
   * Arbeitszeitmodelle
   */
  workingModel: WorkingModelDto | null;
  /**
   * Beschäftigte mit Möglichkeit von zu Hause aus zu arbeiten
   */
  possibleHomeOffice: number | null;
  /**
   * Firmeneigene PKW
   */
  organizationCars: OrganizationCarsDto | null;
  /**
   * PKW-Fahrleistung im Dienst-/ und Geschäftsreiseverkehr (PKW-km/Monat)
   */
  carMileageMonth: number | null;
  /**
   * Firmeneigene Zweiräder
   */
  organizationTwoWheelers: OrganizationTwoWheelersDto | null;
  /**
   * Wie werden Dienstreisen organisiert?
   */
  businessTripOrganization: BusinessTripOrganizationDto | null;
  /**
   * Mit welchem Verkehrsmittel werden Dienst-/Geschäftsreisen i.d.R. unternommen? Verkehrsmittel
   */
  businessTripTransportationType: Array<BusinessTripTransportationType>;
  /**
   * Mit welchem Verkehrsmittel werden Dienst-/Geschäftsreisen i.d.R. unternommen? Sonstiges
   */
  businessTripTransportationOther: string | null;
  /**
   * Wird für den Einsatz der firmeneigenen Poolfahrzeuge eine Dispositionssoftware genutzt
   */
  dispositionSoftwareForPoolCars: boolean | null;
  /**
   * Gibt es Regelungen für die Verkehrsmittelwahl bei Dienst-/Geschäftsreisen
   */
  rulesForChoiceOfTransportModeOnBusinessTrips: boolean | null;
  /**
   * Duschen, Umkleidemöglichkeiten und/oder Spinde für Radfahrer
   */
  bicycleChangingType: Array<BicycleChangingType>;
  /**
   * Verbesserung der Erreichbarkeit des Betriebs für Beschäftigte
   */
  improvementReachability: SurveyImportance | null;
  /**
   * Verbesserung der Erreichbarkeit des Betriebs für Kunden/- innen, Besucher/-innen und Lieferanten
   */
  improvementReachabilityCustomers: SurveyImportance | null;
  /**
   * Verminderung von Parkdruck
   */
  reduceParkingPressure: SurveyImportance | null;
  /**
   * Reduzierung von Kosten für Parkraum
   */
  reduceCostsParking: SurveyImportance | null;
  /**
   * Reduzierung von Kosten für Geschäftsreisen
   */
  reduceCostsBusinessTrips: SurveyImportance | null;
  /**
   * Beitrag des Betriebs zur Reduzierung von Staus
   */
  reduceTrafficJams: SurveyImportance | null;
  /**
   * Erhöhung der Mitarbeiterzufriedenheit
   */
  improvementEmployeeSatisfaction: SurveyImportance | null;
  /**
   * Erhöhung der Produktivität der Mitarbeiter/-innen
   */
  improvementEmployeeProductivity: SurveyImportance | null;
  /**
   * Verminderung von Wegeunfällen
   */
  reduceJourneyAccidents: SurveyImportance | null;
  /**
   * Stärkung der betrieblichen Gesundheitsförderung
   */
  improvementHealthPromotion: SurveyImportance | null;
  /**
   * Verbesserung der Umweltbilanz des Betriebs
   */
  improvementEnvironmentalBalance: SurveyImportance | null;
  /**
   * Einführung von Elektromobilität in den Fuhrpark
   */
  introductionEmobility: SurveyImportance | null;
  /**
   * Ausweitung des Fahrzeugpools um Zweiräder
   */
  expansionBicycle: SurveyImportance | null;
  /**
   * Verbesserung der Öffentlichkeitsarbeit und Imagesteigerung des Betriebs
   */
  improvementPublicImage: SurveyImportance | null;
  /**
   * Verkürzung der Arbeitswege der Beschäftigten durch arbeitsplatznahe Wohnangebote (Kooperationen mit Wohnungsunternehmen)
   */
  reduceJourneyWithHousing: SurveyImportance | null;
  /**
   * Erhöhung der E-Pkw-Nutzung durch die Beschäftigten auf dem Arbeitsweg
   */
  increaseEmployeeEmobility: SurveyImportance | null;
  /**
   * Beitrag des Betriebs zur Verbesserung der Lebens- und Wohnqualität am Standort
   */
  improvementQualityOfLiving: SurveyImportance | null;
  /**
   * Welche der folgenden Maßnahmen und Managementinstrumente sind bei Ihnen im Einsatz oder geplant? Maßnahmen
   */
  managementInstrumentType: Array<ManagementInstrumentType>;
  /**
   * Welche der folgenden Maßnahmen und Managementinstrumente sind bei Ihnen im Einsatz oder geplant? Sonstige
   */
  managementInstrumentOther: string | null;
  /**
   * Wurden Maßnahmen zur Optimierung der (E-)Mobilität früher (auch vergeblich) unternommen?
   */
  eMobilityOptimizationMeasures: YesNoIfYesDescribeDto | null;
  /**
   * Sehen Sie Hindernisse bei der Optimierung der (E-)Mobilität am Standort bzw. unter den Beschäftigten?
   */
  eMobilityOptimizationBarriers: YesNoIfYesDescribeDto | null;
  publicTransportInformationType: Array<PublicTransportInformationType>;
  fundingPublicTransportType: Array<PublicTransportFundingType>;
  carFinancialFundingType: Array<CarFinancialFundingType>;
  /**
   * Fördern Sie speziell die Nutzung von alternativen Antriebsarten?
   */
  alternativeDriveFunding: YesNoIfYesDescribeDto | null;
  /**
   * Bestehen Anreize und Informationen zum energiesparenden und sicheren Autofahren?
   */
  safeAndEcoDrivingIncentive: SafeAndEcoDrivingIncentive | null;
  bicycleIncentiveType: Array<BicycleIncentiveType>;
  carSharingPromotionType: Array<CarSharingPromotionType>;
  /**
   * Wurden weitere Maßnahmen des Mobilitätsmanagements umgesetzt?
   */
  furtherMobilityManagementMeasures: YesNoIfYesDescribeDto | null;
  /**
   * Ausstattung und Qualität der Straßenanbindung
   */
  roadConnectionQualityAndFeatures: string | null;
  /**
   * Nähe des nächsten Autobahnanschlusses: (km)
   */
  roadConnectionHighwayDistance: number | null;
  /**
   * Name des nächstgelegenen Bahnhofs
   */
  trainStationName: string | null;
  /**
   * Entfernung zum nächstgelegenen Bahnhof
   */
  trainStationDistance: DistanceType | null;
  /**
   * Bahnlinien am nächsten Bahnhof
   */
  trainStationLineNames: string | null;
  /**
   * Qualität der Fahrradabstellanlagen am Bahnhof
   */
  trainStationBicycleParking: GoodMediumBad | null;
  /**
   * Lage des Standortes
   */
  locationAreaType: LocationAreaType | null;
  /**
   * Welche Nutzung befindet sich im Umfeld des Betriebes?
   */
  neighbourhoodUsage: NeighbourhoodUsage | null;
  /**
   * Nähe zum nächsten Stadtzentrum: (km)
   */
  distanceToCityCenter: number | null;
  /**
   * Qualität der Zufahrtstraße(n) (Radwege, Verkehrsbehinderung durch Stau, usw.)
   */
  accessRoadQuality: GoodMediumBad | null;
  /**
   * Wird der Parkraum im öffentlichen Raum bewirtschaftet?
   */
  publicSpaceParking: YesNoPartly | null;
  /**
   * Parkplatzsituation im öffentlichen Raum
   */
  publicSpaceParkingLoad: LoadFactor | null;
  /**
   * Radinfrastruktur im Umfeld des Standortes
   */
  neighbourhoodBicycleInfrastructure: NeighbourhoodBicycleInfrastructure | null;
  /**
   * Qualität der Radinfrastruktur im Umfeld des Standortes (Erste Einschätzung - Informationen über Radroutenplaner)
   */
  bicycleInfrastructureNeighbourhood: QualityWithDescriptionDto | null;
  /**
   * Qualität der Radinfrastruktur in das nächstgelegene Zentrum (Erste Einschätzung - Informationen über Radroutenplaner)
   */
  bicycleInfrastructureCityCenter: QualityWithDescriptionDto | null;
  /**
   * Qualität der Radinfrastruktur vom und zum nächsten Bahnhof (Erste Einschätzung - Informationen über Radroutenplaner)
   */
  bicycleInfrastructureTrainStation: QualityWithDescriptionDto | null;
  /**
   * Gibt es ausreichend Zugänge für Fußgänger zum Betriebsgelände (besonders im Bereich der Haltestellen von Bus und Bahn)?
   */
  sufficientAccessForPedestrian: boolean | null;
  pedestrianPathType: Array<PedestrianPathType>;
  /**
   * Gibt es ein S-Bahn-Netz
   */
  publicTransportTrain: YesNoPartly | null;
  /**
   * Gibt es ein U-Bahn-Netz/Straßenbahnnetz?
   */
  publicTransportMetro: YesNoPartly | null;
  /**
   * Name der nächstgelegenen Haltestelle
   */
  publicTransportStop: string | null;
  /**
   * Entfernung zur nächstgelegenen Haltestelle
   */
  publicTransportStopDistance: DistanceType | null;
  /**
   * Fahrzeit (ÖV) vom Betrieb in die Innenstadt des nächsten Mittelzentrums (bzw. Oberzentrums) (sollten mehrere Haltestellen im Umkreis von 500 m am Betrieb liegen, wählen Sie die aus, die am besten bedient wird)
   */
  publicTransportCityDuration: DurationType | null;
  /**
   * Fahrtzeit (ÖV) vom Betrieb zur nächsten Haltestelle mit Übergang zum Schienenverkehr (sollten mehrere Haltestellen im Umkreis von 500 m am Betrieb liegen, wählen Sie die aus, die am besten bedient wird)
   */
  publicTransportTrainDuration: DurationType | null;
  /**
   * Anzahl der Ankünfte der öffentlichen Verkehrsmittel an der Haltestelle werktags zwischen 7-9 Uhr (bzw. zu den für die Beschäftigten relevanten Zeiten) (sollten mehrere Haltestellen im Umkreis von 500 m am Betrieb liegen, wählen Sie die aus, die am besten bedient wird)
   */
  publicTransportArrivalCount: ArrivalCount | null;
  /**
   * Beurteilung des Busliniennetzes
   */
  publicTransportBusQuality: GoodMediumBad | null;
  locationId: string;
  parkingCars: Array<ParkingCarsDto>;
  parkingPermitAllocation: ParkingPermitAllocationDto | null;
  parkingBicycles: Array<ParkingBicyclesDto>;
  publicTransportInformationBool: boolean | null;
  publicTransportInformationOther: string | null;
  fundingPublicTransportBool: boolean | null;
  fundingPublicTransportOther: string | null;
  carFinancialFundingBool: boolean | null;
  carFinancialFundingOther: string | null;
  bicycleIncentiveBool: boolean | null;
  bicycleIncentiveOther: string | null;
  carSharingPromotionBool: boolean | null;
  carSharingPromotionOther: string | null;
  pedestrianPathOther: string | null;
  createdAt: string;
  updatedAt: string;
};

export type Employee = {
  __caslSubjectType__: Subject;
  firstName: string;
  lastName: string;
  locationId: string;
  location?: Location;
  address: string | null;
  lat: number | null;
  lng: number | null;
  id: string;
  createdAt: string;
  updatedAt: string;
};

export type Location = {
  __caslSubjectType__: Subject;
  monitoringCommuteTypes: Array<CommuteType>;
  shareAnalysisPeriod: ShareAnalysisPeriod;
  /**
   * Style für Monitoring
   */
  monitoringStyle: MonitoringStyle;
  /**
   * Ausfüllfortschritt
   */
  coreDataStatus: FillStatus;
  profileStatus: LocationProfileStatus;
  organizationId: string;
  organization?: Organization;
  name: string;
  mainLocation: boolean;
  monitoringActive: boolean;
  monitoringTitle: string | null;
  monitoringQuestion: string | null;
  monitoringScaleMax: number;
  monitoringLinkIdTablet: string;
  monitoringLinkIdSmartphone: string;
  monitoringLinkIdIntranet: string;
  shareAnalysisActive: boolean;
  shareAnalysisLinkId: string;
  shareAnalysisTitle: string | null;
  consultingCaseLocationId: string | null;
  address: string | null;
  size: number | null;
  lat: number | null;
  lng: number | null;
  adminLevelId: string | null;
  adminLevel?: AdminLevel;
  networkIds: Array<string>;
  networks?: Array<Network>;
  profile?: LocationProfile;
  employees?: Array<Employee>;
  id: string;
  createdAt: string;
  updatedAt: string;
};

export enum IndicatorProcessStatus {
  EMPTY = 'EMPTY',
  RELATIONS_UPLOADED = 'RELATIONS_UPLOADED',
  RELATIONS_GEOCODED = 'RELATIONS_GEOCODED',
  READY_FOR_CALCULATION = 'READY_FOR_CALCULATION',
  CALCULATION_DONE = 'CALCULATION_DONE',
  INDICATORS_APPROVED = 'INDICATORS_APPROVED',
}

export type User = {
  __caslSubjectType__: Subject;
  /**
   * Nutzerstatus
   */
  status: UserStatus;
  /**
   * Globale Nutzerrolle
   */
  role: UserRole;
  email: string;
  organizations?: Array<OrganizationUser>;
  indicatorProcesses?: Array<IndicatorProcess>;
  id: string;
  createdAt: string;
  updatedAt: string;
};

export enum IndicatorRelationStatus {
  TODO = 'TODO',
  ERROR = 'ERROR',
  DONE = 'DONE',
}

export enum IndicatorError {
  TECHNICAL_ERROR = 'TECHNICAL_ERROR',
  NO_RESULT = 'NO_RESULT',
}

export type GeocodingErrorsDto = {
  origin?: IndicatorError | null;
  destination?: IndicatorError | null;
};

export type IndicatorErrorsDto = {
  indicators?: IndicatorError | null;
  geocoding?: GeocodingErrorsDto | null;
};

export type IndicatorMiv = {
  __caslSubjectType__: Subject;
  relationId: string;
  relation?: IndicatorRelation;
  distance: number | null;
  journeyTime: number | null;
  parkingTime: number | null;
  comment: string | null;
  id: string;
  createdAt: string;
  updatedAt: string;
};

export type IndicatorBike = {
  __caslSubjectType__: Subject;
  relationId: string;
  relation?: IndicatorRelation;
  distance: number | null;
  journeyTime: number | null;
  ascent: number | null;
  descent: number | null;
  comment: string | null;
  id: string;
  createdAt: string;
  updatedAt: string;
};

export type IndicatorPt = {
  __caslSubjectType__: Subject;
  relationId: string;
  relation?: IndicatorRelation;
  walkDistance: number | null;
  journeyTime: number | null;
  tripTime: number | null;
  changes: number | null;
  comment: string | null;
  id: string;
  createdAt: string;
  updatedAt: string;
};

export type IndicatorPr = {
  __caslSubjectType__: Subject;
  relationId: string;
  relation?: IndicatorRelation;
  mivTime: number | null;
  ptJourneyTime: number | null;
  tripTime: number | null;
  changes: number | null;
  comment: string | null;
  id: string;
  createdAt: string;
  updatedAt: string;
};

export type IndicatorBr = {
  __caslSubjectType__: Subject;
  relationId: string;
  relation?: IndicatorRelation;
  bikeTime: number | null;
  ptJourneyTime: number | null;
  tripTime: number | null;
  changes: number | null;
  comment: string | null;
  id: string;
  createdAt: string;
  updatedAt: string;
};

export type IndicatorRelation = {
  __caslSubjectType__: Subject;
  geocodingStatus: IndicatorRelationStatus;
  indicatorsStatus: IndicatorRelationStatus;
  processId: string;
  process?: IndicatorProcess;
  ivmId: number | null;
  description: string | null;
  originAddress: string | null;
  originLatitude: number | null;
  originLongitude: number | null;
  destinationAddress: string | null;
  destinationLatitude: number | null;
  destinationLongitude: number | null;
  errors: IndicatorErrorsDto | null;
  consultingCaseLocationId: string | null;
  indicatorMiv?: Array<IndicatorMiv>;
  indicatorBike?: Array<IndicatorBike>;
  indicatorPt?: Array<IndicatorPt>;
  indicatorPr?: Array<IndicatorPr>;
  indicatorBr?: Array<IndicatorBr>;
  id: string;
  createdAt: string;
  updatedAt: string;
};

export type IndicatorProcess = {
  __caslSubjectType__: Subject;
  relationsTotalCount?: number;
  relationsGeocodingDoneCount?: number;
  relationsIndicatorsDoneCount?: number;
  status: IndicatorProcessStatus;
  name: string;
  organizationId: string | null;
  organization?: Organization;
  arrivalSpanFrom: string | null;
  arrivalSpanTo: string | null;
  dateOfRelations: string | null;
  uploader?: User;
  relations?: Array<IndicatorRelation>;
  id: string;
  createdAt: string;
  updatedAt: string;
};

export type Organization = {
  __caslSubjectType__: Subject;
  /**
   * Branche
   */
  sector: Sector | null;
  /**
   * Beratungsprozess Status
   */
  status: ConsultingStatus;
  /**
   * Ausfüllfortschritt
   */
  coreDataStatus: FillStatus;
  name: string;
  ivmId: string | null;
  consultingCaseId: string | null;
  participationDate: string | null;
  fileStorage: string | null;
  size: number | null;
  contactFirstName: string | null;
  contactLastName: string | null;
  contactTel: string | null;
  contactMail: string | null;
  locations?: Array<Location>;
  users?: Array<OrganizationUser>;
  processes?: Array<IndicatorProcess>;
  id: string;
  createdAt: string;
  updatedAt: string;
};

export type OrganizationUser = {
  __caslSubjectType__: Subject;
  /**
   * Nutzerrolle innerhalb des Arbeitgebers
   */
  role: OrganizationUserRole;
  organizationId: string;
  userId: string;
  organization?: Organization;
  user?: User;
  createdAt: string;
  updatedAt: string;
};

export type ForgotPasswordDto = {
  email: string;
};

export type ResetPasswordDto = {
  passwordResetToken: string;
  newPassword: string;
};

export enum Action {
  MANAGE = 'MANAGE',
  CREATE = 'CREATE',
  READ = 'READ',
  READ_ALL = 'READ_ALL',
  UPDATE = 'UPDATE',
  DELETE = 'DELETE',
}

export type CaslEnumDto = {
  action: Action;
  subject: Subject;
};

export type CaslRulesDto = {
  rules: Array<Array<Action | Subject | string | number | Record<string, unknown>>>;
};

export type CreateUserDto = {
  role: UserRole;
  email: string;
};

export type UpdateUserDto = {
  status?: UserStatus;
  oldPassword?: string;
  newPassword?: string;
  email?: string;
};

export type AcceptInvitationDto = {
  password: string;
};

export type CreateOrganizationDto = {
  /**
   * Name des Arbeitgebers
   */
  name: string;
  /**
   * Beratungsfall-Nr.
   */
  consultingCaseId?: string | null;
  /**
   * Teilnahmejahr
   */
  participationDate?: string | null;
  /**
   * Branche
   */
  sector?: Sector | null;
  /**
   * Link zur Dokumentenablage
   */
  fileStorage?: string | null;
  /**
   * Anzahl der Beschäftigten beim Arbeitgeber
   */
  size?: number | null;
  /**
   * Vorname Kontaktperson
   */
  contactFirstName?: string | null;
  /**
   * Nachname Kontaktperson
   */
  contactLastName?: string | null;
  /**
   * Telefonnummer Kontaktperson
   */
  contactTel?: string | null;
  /**
   * E-Mail Kontaktperson
   */
  contactMail?: string | null;
  /**
   * Beratungsprozess Status
   */
  status?: ConsultingStatus;
};

export type UpdateOrganizationDto = {
  /**
   * Name des Arbeitgebers
   */
  name?: string;
  /**
   * Beratungsfall-Nr.
   */
  consultingCaseId?: string | null;
  /**
   * Teilnahmejahr
   */
  participationDate?: string | null;
  /**
   * Branche
   */
  sector?: Sector | null;
  /**
   * Link zur Dokumentenablage
   */
  fileStorage?: string | null;
  /**
   * Anzahl der Beschäftigten beim Arbeitgeber
   */
  size?: number | null;
  /**
   * Vorname Kontaktperson
   */
  contactFirstName?: string | null;
  /**
   * Nachname Kontaktperson
   */
  contactLastName?: string | null;
  /**
   * Telefonnummer Kontaktperson
   */
  contactTel?: string | null;
  /**
   * E-Mail Kontaktperson
   */
  contactMail?: string | null;
  /**
   * Beratungsprozess Status
   */
  status?: ConsultingStatus;
};

export type CreateLocationDto = {
  /**
   * ID des Arbeitgebers
   */
  organizationId: string;
  /**
   * Name des Standorts
   */
  name: string;
};

export type UpdateLocationDto = {
  /**
   * Name des Standorts
   */
  name?: string;
  /**
   * Hauptstandort
   */
  mainLocation?: boolean;
  /**
   * Monitoring aktiv
   */
  monitoringActive?: boolean;
  /**
   * Monitoring Überschrift
   */
  monitoringTitle?: string | null;
  /**
   * Monitoring Frage
   */
  monitoringQuestion?: string | null;
  /**
   * Verkehrsmittel für Monitoring
   */
  monitoringCommuteTypes?: Array<CommuteType>;
  /**
   * Maximalwert für Entfernung bei Monitoring Skala
   */
  monitoringScaleMax?: number;
  monitoringStyle?: MonitoringStyle;
  shareAnalysisPeriod?: ShareAnalysisPeriod;
  /**
   * Überschrift freigegebene Ergebnisseite
   */
  shareAnalysisTitle?: string | null;
  /**
   * Standort-Nr.
   */
  consultingCaseLocationId?: string | null;
  /**
   * Adresse des Standorts
   */
  address?: string | null;
  /**
   * Anzahl der Beschäftigten am Standort
   */
  size?: number | null;
  /**
   * Latitude Koordinate des Standorts
   */
  lat?: number | null;
  /**
   * Longitude Koordinate des Standorts
   */
  lng?: number | null;
  /**
   * Name der Kontaktperson
   */
  contactName?: string | null;
  /**
   * Telefonnummer der Kontaktperson
   */
  contactTel?: string | null;
  /**
   * E-Mail Adresse der Kontaktperson
   */
  contactMail?: string | null;
  /**
   * Zuordnung zur Räumlichen Ebene mittels ID
   */
  adminLevelId?: string | null;
  /**
   * Zuordnung der Netzwerke mittels ID
   */
  networkIds?: Array<string>;
  profileStatus?: LocationProfileStatus;
  shareAnalysisActive?: boolean;
};

export type UpdateLocationProfileDto = {
  /**
   * Art des Gebäudes / Grundstücks
   */
  buildingType?: BuildingType | null;
  /**
   * Geschlechterverteilung der Beschäftigten
   */
  genderDistribution?: GenderDistributionDto | null;
  /**
   * Altersverteilung der Beschäftigten
   */
  ageDistribution?: AgeDistributionDto | null;
  /**
   * Anzahl der Kunden/Besucher je Woche
   */
  customersPerWeek?: number | null;
  /**
   * Arbeitszeitmodelle
   */
  workingModel?: WorkingModelDto | null;
  /**
   * Beschäftigte mit Möglichkeit von zu Hause aus zu arbeiten
   */
  possibleHomeOffice?: number | null;
  /**
   * Firmeneigene PKW
   */
  organizationCars?: OrganizationCarsDto | null;
  /**
   * PKW-Fahrleistung im Dienst-/ und Geschäftsreiseverkehr (PKW-km/Monat)
   */
  carMileageMonth?: number | null;
  /**
   * Firmeneigene Zweiräder
   */
  organizationTwoWheelers?: OrganizationTwoWheelersDto | null;
  /**
   * Wie werden Dienstreisen organisiert?
   */
  businessTripOrganization?: BusinessTripOrganizationDto | null;
  /**
   * Wird für den Einsatz der firmeneigenen Poolfahrzeuge eine Dispositionssoftware genutzt
   */
  dispositionSoftwareForPoolCars?: boolean | null;
  /**
   * Gibt es Regelungen für die Verkehrsmittelwahl bei Dienst-/Geschäftsreisen
   */
  rulesForChoiceOfTransportModeOnBusinessTrips?: boolean | null;
  /**
   * Verbesserung der Erreichbarkeit des Betriebs für Beschäftigte
   */
  improvementReachability?: SurveyImportance | null;
  /**
   * Verbesserung der Erreichbarkeit des Betriebs für Kunden/- innen, Besucher/-innen und Lieferanten
   */
  improvementReachabilityCustomers?: SurveyImportance | null;
  /**
   * Verminderung von Parkdruck
   */
  reduceParkingPressure?: SurveyImportance | null;
  /**
   * Reduzierung von Kosten für Parkraum
   */
  reduceCostsParking?: SurveyImportance | null;
  /**
   * Reduzierung von Kosten für Geschäftsreisen
   */
  reduceCostsBusinessTrips?: SurveyImportance | null;
  /**
   * Beitrag des Betriebs zur Reduzierung von Staus
   */
  reduceTrafficJams?: SurveyImportance | null;
  /**
   * Erhöhung der Mitarbeiterzufriedenheit
   */
  improvementEmployeeSatisfaction?: SurveyImportance | null;
  /**
   * Erhöhung der Produktivität der Mitarbeiter/-innen
   */
  improvementEmployeeProductivity?: SurveyImportance | null;
  /**
   * Verminderung von Wegeunfällen
   */
  reduceJourneyAccidents?: SurveyImportance | null;
  /**
   * Stärkung der betrieblichen Gesundheitsförderung
   */
  improvementHealthPromotion?: SurveyImportance | null;
  /**
   * Verbesserung der Umweltbilanz des Betriebs
   */
  improvementEnvironmentalBalance?: SurveyImportance | null;
  /**
   * Einführung von Elektromobilität in den Fuhrpark
   */
  introductionEmobility?: SurveyImportance | null;
  /**
   * Ausweitung des Fahrzeugpools um Zweiräder
   */
  expansionBicycle?: SurveyImportance | null;
  /**
   * Verbesserung der Öffentlichkeitsarbeit und Imagesteigerung des Betriebs
   */
  improvementPublicImage?: SurveyImportance | null;
  /**
   * Verkürzung der Arbeitswege der Beschäftigten durch arbeitsplatznahe Wohnangebote (Kooperationen mit Wohnungsunternehmen)
   */
  reduceJourneyWithHousing?: SurveyImportance | null;
  /**
   * Erhöhung der E-Pkw-Nutzung durch die Beschäftigten auf dem Arbeitsweg
   */
  increaseEmployeeEmobility?: SurveyImportance | null;
  /**
   * Beitrag des Betriebs zur Verbesserung der Lebens- und Wohnqualität am Standort
   */
  improvementQualityOfLiving?: SurveyImportance | null;
  /**
   * Wurden Maßnahmen zur Optimierung der (E-)Mobilität früher (auch vergeblich) unternommen?
   */
  eMobilityOptimizationMeasures?: YesNoIfYesDescribeDto | null;
  /**
   * Sehen Sie Hindernisse bei der Optimierung der (E-)Mobilität am Standort bzw. unter den Beschäftigten?
   */
  eMobilityOptimizationBarriers?: YesNoIfYesDescribeDto | null;
  /**
   * Fördern Sie speziell die Nutzung von alternativen Antriebsarten?
   */
  alternativeDriveFunding?: YesNoIfYesDescribeDto | null;
  /**
   * Bestehen Anreize und Informationen zum energiesparenden und sicheren Autofahren?
   */
  safeAndEcoDrivingIncentive?: SafeAndEcoDrivingIncentive | null;
  /**
   * Wurden weitere Maßnahmen des Mobilitätsmanagements umgesetzt?
   */
  furtherMobilityManagementMeasures?: YesNoIfYesDescribeDto | null;
  /**
   * Ausstattung und Qualität der Straßenanbindung
   */
  roadConnectionQualityAndFeatures?: string | null;
  /**
   * Nähe des nächsten Autobahnanschlusses: (km)
   */
  roadConnectionHighwayDistance?: number | null;
  /**
   * Name des nächstgelegenen Bahnhofs
   */
  trainStationName?: string | null;
  /**
   * Entfernung zum nächstgelegenen Bahnhof
   */
  trainStationDistance?: DistanceType | null;
  /**
   * Bahnlinien am nächsten Bahnhof
   */
  trainStationLineNames?: string | null;
  /**
   * Qualität der Fahrradabstellanlagen am Bahnhof
   */
  trainStationBicycleParking?: GoodMediumBad | null;
  /**
   * Lage des Standortes
   */
  locationAreaType?: LocationAreaType | null;
  /**
   * Welche Nutzung befindet sich im Umfeld des Betriebes?
   */
  neighbourhoodUsage?: NeighbourhoodUsage | null;
  /**
   * Nähe zum nächsten Stadtzentrum: (km)
   */
  distanceToCityCenter?: number | null;
  /**
   * Qualität der Zufahrtstraße(n) (Radwege, Verkehrsbehinderung durch Stau, usw.)
   */
  accessRoadQuality?: GoodMediumBad | null;
  /**
   * Wird der Parkraum im öffentlichen Raum bewirtschaftet?
   */
  publicSpaceParking?: YesNoPartly | null;
  /**
   * Parkplatzsituation im öffentlichen Raum
   */
  publicSpaceParkingLoad?: LoadFactor | null;
  /**
   * Radinfrastruktur im Umfeld des Standortes
   */
  neighbourhoodBicycleInfrastructure?: NeighbourhoodBicycleInfrastructure | null;
  /**
   * Qualität der Radinfrastruktur im Umfeld des Standortes (Erste Einschätzung - Informationen über Radroutenplaner)
   */
  bicycleInfrastructureNeighbourhood?: QualityWithDescriptionDto | null;
  /**
   * Qualität der Radinfrastruktur in das nächstgelegene Zentrum (Erste Einschätzung - Informationen über Radroutenplaner)
   */
  bicycleInfrastructureCityCenter?: QualityWithDescriptionDto | null;
  /**
   * Qualität der Radinfrastruktur vom und zum nächsten Bahnhof (Erste Einschätzung - Informationen über Radroutenplaner)
   */
  bicycleInfrastructureTrainStation?: QualityWithDescriptionDto | null;
  /**
   * Gibt es ausreichend Zugänge für Fußgänger zum Betriebsgelände (besonders im Bereich der Haltestellen von Bus und Bahn)?
   */
  sufficientAccessForPedestrian?: boolean | null;
  /**
   * Gibt es ein S-Bahn-Netz
   */
  publicTransportTrain?: YesNoPartly | null;
  /**
   * Gibt es ein U-Bahn-Netz/Straßenbahnnetz?
   */
  publicTransportMetro?: YesNoPartly | null;
  /**
   * Name der nächstgelegenen Haltestelle
   */
  publicTransportStop?: string | null;
  /**
   * Entfernung zur nächstgelegenen Haltestelle
   */
  publicTransportStopDistance?: DistanceType | null;
  /**
   * Fahrzeit (ÖV) vom Betrieb in die Innenstadt des nächsten Mittelzentrums (bzw. Oberzentrums) (sollten mehrere Haltestellen im Umkreis von 500 m am Betrieb liegen, wählen Sie die aus, die am besten bedient wird)
   */
  publicTransportCityDuration?: DurationType | null;
  /**
   * Fahrtzeit (ÖV) vom Betrieb zur nächsten Haltestelle mit Übergang zum Schienenverkehr (sollten mehrere Haltestellen im Umkreis von 500 m am Betrieb liegen, wählen Sie die aus, die am besten bedient wird)
   */
  publicTransportTrainDuration?: DurationType | null;
  /**
   * Anzahl der Ankünfte der öffentlichen Verkehrsmittel an der Haltestelle werktags zwischen 7-9 Uhr (bzw. zu den für die Beschäftigten relevanten Zeiten) (sollten mehrere Haltestellen im Umkreis von 500 m am Betrieb liegen, wählen Sie die aus, die am besten bedient wird)
   */
  publicTransportArrivalCount?: ArrivalCount | null;
  /**
   * Beurteilung des Busliniennetzes
   */
  publicTransportBusQuality?: GoodMediumBad | null;
  /**
   * Mit welchem Verkehrsmittel werden Dienst-/Geschäftsreisen i.d.R. unternommen? Verkehrsmittel
   */
  businessTripTransportationType?: Array<BusinessTripTransportationType>;
  /**
   * Mit welchem Verkehrsmittel werden Dienst-/Geschäftsreisen i.d.R. unternommen? Sonstiges
   */
  businessTripTransportationOther?: string | null;
  /**
   * PKW Stellplatzanlagen
   */
  parkingCars?: Array<ParkingCarsDto>;
  /**
   * Kriterien zur Vergabe von Parkberechtigungen
   */
  parkingPermitAllocation?: ParkingPermitAllocationDto | null;
  /**
   * Fahrrad Abstellanlagen
   */
  parkingBicycles?: Array<ParkingBicyclesDto>;
  /**
   * Duschen, Umkleidemöglichkeiten und/oder Spinde für Radfahrer
   */
  bicycleChangingType?: Array<BicycleChangingType>;
  /**
   * Welche der folgenden Maßnahmen und Managementinstrumente sind bei Ihnen im Einsatz oder geplant? Maßnahmen
   */
  managementInstrumentType?: Array<ManagementInstrumentType>;
  /**
   * Welche der folgenden Maßnahmen und Managementinstrumente sind bei Ihnen im Einsatz oder geplant? Sonstige
   */
  managementInstrumentOther?: string | null;
  /**
   * Stehen Ihren Beschäftigten am Arbeitsplatz Informationen zum öffentlichen Verkehr zur Verfügung? Ja / Nein
   */
  publicTransportInformationBool?: boolean | null;
  /**
   * Stehen Ihren Beschäftigten am Arbeitsplatz Informationen zum öffentlichen Verkehr zur Verfügung? Type
   */
  publicTransportInformationType?: Array<PublicTransportInformationType>;
  /**
   * Stehen Ihren Beschäftigten am Arbeitsplatz Informationen zum öffentlichen Verkehr zur Verfügung? Sonstige
   */
  publicTransportInformationOther?: string | null;
  /**
   * Fördern Sie die Nutzung von öffentlichen Verkehrsmitteln durch Ihre Mitarbeiter/innen? Ja / Nein
   */
  fundingPublicTransportBool?: boolean | null;
  /**
   * Fördern Sie die Nutzung von öffentlichen Verkehrsmitteln durch Ihre Mitarbeiter/innen? Type
   */
  fundingPublicTransportType?: Array<PublicTransportFundingType>;
  /**
   * Fördern Sie die Nutzung von öffentlichen Verkehrsmitteln durch Ihre Mitarbeiter/innen? Sonstige
   */
  fundingPublicTransportOther?: string | null;
  /**
   * Fördern Sie die Nutzung des Pkw durch Ihre Mitarbeiter/innen finanziell? Ja / Nein
   */
  carFinancialFundingBool?: boolean | null;
  /**
   * Fördern Sie die Nutzung des Pkw durch Ihre Mitarbeiter/innen finanziell? Type
   */
  carFinancialFundingType?: Array<CarFinancialFundingType>;
  /**
   * Fördern Sie die Nutzung des Pkw durch Ihre Mitarbeiter/innen finanziell? Sonstige
   */
  carFinancialFundingOther?: string | null;
  /**
   * Fördern Sie die Fahrradnutzung durch Ihre Mitarbeiter/innen? Ja / Nein
   */
  bicycleIncentiveBool?: boolean | null;
  /**
   * Fördern Sie die Fahrradnutzung durch Ihre Mitarbeiter/innen? Type
   */
  bicycleIncentiveType?: Array<BicycleIncentiveType>;
  /**
   * Fördern Sie die Fahrradnutzung durch Ihre Mitarbeiter/innen? Sonstige
   */
  bicycleIncentiveOther?: string | null;
  /**
   * Verfügt Ihr Betrieb über ein Förderprogramm zum gemeinsamen Autofahren (Fahrgemeinschaft)? Ja / Nein
   */
  carSharingPromotionBool?: boolean | null;
  /**
   * Verfügt Ihr Betrieb über ein Förderprogramm zum gemeinsamen Autofahren (Fahrgemeinschaft)? Type
   */
  carSharingPromotionType?: Array<CarSharingPromotionType>;
  /**
   * Verfügt Ihr Betrieb über ein Förderprogramm zum gemeinsamen Autofahren (Fahrgemeinschaft)? Sonstige
   */
  carSharingPromotionOther?: string | null;
  /**
   * Zugangsqualität für Fußgänger. Type
   */
  pedestrianPathType?: Array<PedestrianPathType>;
  /**
   * Zugangsqualität für Fußgänger. Sonstiges
   */
  pedestrianPathOther?: string | null;
};

export type CreateEmployeeDto = {
  /**
   * Adresse des Beschäftigten
   */
  address?: string | null;
  /**
   * Latitude Koordinate der Adresse
   */
  lat?: number | null;
  /**
   * Longitude Koordinate der Adresse
   */
  lng?: number | null;
  firstName: string;
  lastName: string;
  locationId: string;
};

export type UpdateEmployeeDto = {
  /**
   * Adresse des Beschäftigten
   */
  address?: string | null;
  /**
   * Latitude Koordinate der Adresse
   */
  lat?: number | null;
  /**
   * Longitude Koordinate der Adresse
   */
  lng?: number | null;
  firstName?: string;
  lastName?: string;
  locationId?: string;
};

export type CreateNetworkDto = {
  /**
   * Netzwerkkategorie
   */
  category: NetworkCategory;
  name: string;
};

export type UpdateNetworkDto = {
  /**
   * Zuordnung Standorte zu Netzwerk über Ids
   */
  locationIds?: Array<string>;
  name: string;
};

export type CreateAdminLevelDto = unknown;

export type UpdateAdminLevelDto = {
  publication?: boolean | null;
};

export type CreateOrganizationUserDto = {
  /**
   * Nutzerrolle innerhalb des Arbeitgebers
   */
  role: OrganizationUserRole;
  organizationId: string;
  userEmail: string;
};

export type UpdateOrganizationUserDto = {
  /**
   * Nutzerrolle innerhalb des Arbeitgebers
   */
  role: OrganizationUserRole;
};

export type CreateInterestDto = {
  /**
   * Name des Arbeitgebers
   */
  organizationName: string;
  /**
   * Anzahl der Beschäftigten beim Arbeitgeber
   */
  organizationSize: number;
  /**
   * Stadt / Ort Hauptstandort
   */
  organizationPlace: string;
  /**
   * Vorname Kontaktperson
   */
  contactFirstName: string;
  /**
   * Nachname Kontaktperson
   */
  contactLastName: string;
  /**
   * E-Mail Adresse Kontaktperson
   */
  contactEmail: string;
  /**
   * Telefonnummer der Kontaktperson
   */
  contactTel: string;
};

export type CreateIndicatorProcessDto = {
  organizationId?: string | null;
  name: string;
};

export type CreateIndicatorRelationDto = {
  ivmId?: number | null;
  description?: string | null;
  originAddress?: string | null;
  originLatitude?: number | null;
  originLongitude?: number | null;
  destinationAddress?: string | null;
  destinationLatitude?: number | null;
  destinationLongitude?: number | null;
  consultingCaseLocationId?: string | null;
};

export type UpdateIndicatorProcessDto = {
  status?: IndicatorProcessStatus;
  dateOfRelations?: string | null;
  relations?: Array<CreateIndicatorRelationDto>;
  arrivalSpanFrom?: string | null;
  arrivalSpanTo?: string | null;
  name?: string;
};

export enum IndicatorType {
  REL = 'REL',
  BIKE = 'BIKE',
  WALK = 'WALK',
  MIV = 'MIV',
  PT = 'PT',
  PR = 'PR',
  BR = 'BR',
}

export type IndicatorRoutingQueueStatusDto = {
  cronJobsScheduled: boolean;
  queueIsPaused: boolean;
  queueActiveCount: number;
  queueWaitingCount: number;
  queueCompletedCount: number;
  queueFailedCount: number;
};

export type IndicatorRoutingConfiguration = {
  __caslSubjectType__: Subject;
  queueRunning: boolean;
  cronJobsScheduled: boolean;
  weekdaysFrom: string;
  weekdaysTo: string;
  weekendsFrom: string;
  weekendsTo: string;
  id: string;
  createdAt: string;
  updatedAt: string;
};

export type UpdateIndicatorRoutingConfigurationDto = {
  weekdaysFrom?: string | null;
  weekdaysTo?: string | null;
  weekendsFrom?: string | null;
  weekendsTo?: string | null;
};

/**
 * Monitoring Link Type
 */
export enum MonitoringLinkType {
  TABLET = 'TABLET',
  SMARTPHONE = 'SMARTPHONE',
  INTRANET = 'INTRANET',
  SHARE_ANALYSIS = 'SHARE_ANALYSIS',
}

export type SummaryMonitoringDto = {
  /**
   * Verkehrsmittel
   */
  commuteType: CommuteType;
  /**
   * Summe
   */
  count: number;
  day: string;
};

export type MonitoringLocationDto = {
  /**
   * Style für Monitoring
   */
  monitoringStyle: MonitoringStyle;
  /**
   * Monitoring Link Type
   */
  linkType: MonitoringLinkType;
  shareAnalysisPeriod?: ShareAnalysisPeriod;
  name: string;
  locationId: string;
  monitoringActive: boolean;
  monitoringTitle?: string | null;
  monitoringQuestion?: string | null;
  monitoringCommuteTypes: Array<
    | 'HOME_OFFICE'
    | 'WALK'
    | 'BIKE'
    | 'BIKE_AND_RIDE'
    | 'PARK_AND_RIDE'
    | 'PUBLIC_TRANSPORT'
    | 'CAR_POOL'
    | 'CAR_MOTORCYCLE'
    | 'CAR_ELECTRIC'
    | 'LONG_DISTANCE_TRANSPORT'
    | 'SCOOTER'
    | 'MOPED'
    | 'E_SCOOTER'
    | 'PARENT_TAXI'
  >;
  monitoringScaleMax: number;
  summary?: Array<SummaryMonitoringDto>;
  shareAnalysisTitle?: string | null;
};

export type CreateMonitoringDto = {
  /**
   * Mit welchem Verkehrsmittel sind Sie heute zur Arbeit gekommen?
   */
  commuteType: CommuteType;
  /**
   * Entfernung Wohnort Arbeitsort (km)
   */
  distance: number;
  locationId: string;
};

export type Monitoring = {
  __caslSubjectType__: Subject;
  location: Location;
  commuteType:
    | 'HOME_OFFICE'
    | 'WALK'
    | 'BIKE'
    | 'BIKE_AND_RIDE'
    | 'PARK_AND_RIDE'
    | 'PUBLIC_TRANSPORT'
    | 'CAR_POOL'
    | 'CAR_MOTORCYCLE'
    | 'CAR_ELECTRIC'
    | 'LONG_DISTANCE_TRANSPORT'
    | 'SCOOTER'
    | 'MOPED'
    | 'E_SCOOTER'
    | 'PARENT_TAXI';
  distance: number;
  id: string;
  createdAt: string;
  updatedAt: string;
};

export type AnalyseMonitoringDto = {
  adminLevelId?: string;
  networkId?: string;
  organizationId?: string;
  locationId?: string;
  start: string;
  end: string;
  includeWayBack: boolean;
};

export type MinimumMonitoringDto = {
  /**
   * Mit welchem Verkehrsmittel sind Sie heute zur Arbeit gekommen?
   */
  commuteType: CommuteType;
  /**
   * Entfernung Wohnort Arbeitsort (km)
   */
  distance: number;
  createdAt: string;
  locationId?: string;
};

export type MonitoringAnalysisData = {
  commuteType: CommuteType;
  activeMobility: boolean;
  movementShare: number;
  count: number;
  distance: number;
  carbonDioxide: number;
  reducedCarbonDioxide: number;
  order: number;
  data: Array<MinimumMonitoringDto>;
};

export type PublicAnalyseMonitoringDto = {
  adminLevelId?: string;
  networkId?: string;
  start: string;
  end: string;
  includeWayBack: boolean;
};

export type $OpenApiTs = {
  '/api/v1/authentication': {
    post: {
      req: {
        requestBody: LoginUserDto;
      };
      res: {
        201: User;
      };
    };
    get: {
      res: {
        200: User;
      };
    };
    delete: {
      res: {
        204: void;
      };
    };
  };
  '/api/v1/authentication/forgot-password': {
    post: {
      req: {
        requestBody: ForgotPasswordDto;
      };
      res: {
        201: any;
      };
    };
  };
  '/api/v1/authentication/reset-password': {
    post: {
      req: {
        requestBody: ResetPasswordDto;
      };
      res: {
        201: any;
      };
    };
  };
  '/api/v1/health': {
    get: {
      res: {
        /**
         * The Health Check is successful
         */
        200: {
          status?: string;
          info?: Record<
            string,
            {
              status: string;
              [key: string]: unknown;
            }
          > | null;
          error?: Record<
            string,
            {
              status: string;
              [key: string]: unknown;
            }
          > | null;
          details?: Record<
            string,
            {
              status: string;
              [key: string]: unknown;
            }
          >;
        };
      };
    };
  };
  '/api/v1/casl': {
    get: {
      res: {
        200: CaslRulesDto;
      };
    };
  };
  '/api/v1/users': {
    post: {
      req: {
        requestBody: CreateUserDto;
      };
      res: {
        201: User;
      };
    };
    get: {
      req: {
        role?: Array<UserRole>;
        search?: string;
        status?: Array<UserStatus>;
      };
      res: {
        200: Array<User>;
      };
    };
  };
  '/api/v1/users/{id}': {
    get: {
      req: {
        id: string;
      };
      res: {
        200: User;
      };
    };
    patch: {
      req: {
        id: string;
        requestBody: UpdateUserDto;
      };
      res: {
        200: User;
      };
    };
    delete: {
      req: {
        id: string;
      };
      res: {
        200: User;
      };
    };
  };
  '/api/v1/invitations/{userId}': {
    patch: {
      req: {
        invitationToken: string;
        requestBody: AcceptInvitationDto;
        userId: string;
      };
      res: {
        200: User;
      };
    };
  };
  '/api/v1/organizations': {
    post: {
      req: {
        requestBody: CreateOrganizationDto;
      };
      res: {
        201: Organization;
      };
    };
    get: {
      req: {
        adminLevelId?: string;
        employeeRange?: Array<number>;
        includeLocations?: boolean;
        networkId?: string;
        search?: string;
        status?: Array<ConsultingStatus>;
      };
      res: {
        200: Array<Organization>;
      };
    };
  };
  '/api/v1/organizations/{id}': {
    get: {
      req: {
        id: string;
        includeIndicatorProcesses?: boolean;
        includeLocations?: boolean;
        includeOrganizationUsers?: boolean;
      };
      res: {
        200: Organization;
      };
    };
    patch: {
      req: {
        id: string;
        requestBody: UpdateOrganizationDto;
      };
      res: {
        200: Organization;
      };
    };
    delete: {
      req: {
        id: string;
      };
      res: {
        200: Organization;
      };
    };
  };
  '/api/v1/locations': {
    post: {
      req: {
        requestBody: CreateLocationDto;
      };
      res: {
        201: Location;
      };
    };
    get: {
      req: {
        profileStatus?: Array<LocationProfileStatus>;
        search?: string;
      };
      res: {
        200: Array<Location>;
      };
    };
  };
  '/api/v1/locations/{id}': {
    get: {
      req: {
        id: string;
      };
      res: {
        200: Location;
      };
    };
    patch: {
      req: {
        id: string;
        requestBody: UpdateLocationDto;
      };
      res: {
        200: Location;
      };
    };
    delete: {
      req: {
        id: string;
      };
      res: {
        200: Location;
      };
    };
  };
  '/api/v1/location-profiles/{locationId}': {
    get: {
      req: {
        locationId: string;
      };
      res: {
        200: LocationProfile;
      };
    };
    patch: {
      req: {
        locationId: string;
        requestBody: UpdateLocationProfileDto;
      };
      res: {
        200: Record<string, unknown>;
      };
    };
  };
  '/api/v1/employees': {
    post: {
      req: {
        requestBody: CreateEmployeeDto;
      };
      res: {
        201: Employee;
      };
    };
    get: {
      res: {
        200: Array<Employee>;
      };
    };
  };
  '/api/v1/employees/{id}': {
    get: {
      req: {
        id: string;
      };
      res: {
        200: Employee;
      };
    };
    patch: {
      req: {
        id: string;
        requestBody: UpdateEmployeeDto;
      };
      res: {
        200: Employee;
      };
    };
    delete: {
      req: {
        id: string;
      };
      res: {
        200: Employee;
      };
    };
  };
  '/api/v1/networks': {
    post: {
      req: {
        requestBody: CreateNetworkDto;
      };
      res: {
        201: Network;
      };
    };
    get: {
      res: {
        200: Array<Network>;
      };
    };
  };
  '/api/v1/networks/{id}': {
    get: {
      req: {
        id: string;
        includeLocations?: boolean;
      };
      res: {
        200: Network;
      };
    };
    patch: {
      req: {
        id: string;
        requestBody: UpdateNetworkDto;
      };
      res: {
        200: Network;
      };
    };
    delete: {
      req: {
        id: string;
      };
      res: {
        200: Network;
      };
    };
  };
  '/api/v1/admin-levels': {
    post: {
      req: {
        requestBody: CreateAdminLevelDto;
      };
      res: {
        201: AdminLevel;
      };
    };
    get: {
      req: {
        depth?: number;
        publication?: boolean;
        /**
         * Räumlicher Ebenentyp
         */
        type?: Array<AdminLevelType>;
      };
      res: {
        200: Array<AdminLevel>;
      };
    };
  };
  '/api/v1/admin-levels/{id}': {
    get: {
      req: {
        id: string;
        includeLocations?: boolean;
      };
      res: {
        200: AdminLevel;
      };
    };
    patch: {
      req: {
        id: string;
        requestBody: UpdateAdminLevelDto;
      };
      res: {
        200: AdminLevel;
      };
    };
    delete: {
      req: {
        id: string;
      };
      res: {
        200: AdminLevel;
      };
    };
  };
  '/api/v1/organization-users': {
    post: {
      req: {
        requestBody: CreateOrganizationUserDto;
      };
      res: {
        201: OrganizationUser;
      };
    };
    get: {
      req: {
        includeUsers?: boolean;
        organizationId?: string;
        search?: string;
      };
      res: {
        200: Array<OrganizationUser>;
      };
    };
  };
  '/api/v1/organization-users/{organizationId}/{userId}': {
    patch: {
      req: {
        organizationId: string;
        requestBody: UpdateOrganizationUserDto;
        userId: string;
      };
      res: {
        200: OrganizationUser;
      };
    };
    delete: {
      req: {
        organizationId: string;
        userId: string;
      };
      res: {
        200: OrganizationUser;
      };
    };
  };
  '/api/v1/interests': {
    post: {
      req: {
        requestBody: CreateInterestDto;
      };
      res: {
        201: CreateInterestDto;
      };
    };
  };
  '/api/v1/indicator-processes': {
    post: {
      req: {
        requestBody: CreateIndicatorProcessDto;
      };
      res: {
        201: IndicatorProcess;
      };
    };
    get: {
      req: {
        independent: boolean;
        search?: string;
      };
      res: {
        200: Array<IndicatorProcess>;
      };
    };
  };
  '/api/v1/indicator-processes/{id}': {
    get: {
      req: {
        id: string;
      };
      res: {
        200: IndicatorProcess;
      };
    };
    patch: {
      req: {
        id: string;
        requestBody: UpdateIndicatorProcessDto;
      };
      res: {
        200: IndicatorProcess;
      };
    };
    delete: {
      req: {
        id: string;
      };
      res: {
        200: any;
      };
    };
  };
  '/api/v1/indicator-processes/{id}/export': {
    get: {
      req: {
        id: string;
        indicatorType: IndicatorType;
      };
      res: {
        200: any;
      };
    };
  };
  '/api/v1/indicator-routing-queue': {
    get: {
      res: {
        200: IndicatorRoutingQueueStatusDto;
      };
    };
    post: {
      res: {
        201: any;
      };
    };
    delete: {
      res: {
        200: any;
      };
    };
  };
  '/api/v1/indicator-routing-queue/cron-jobs': {
    post: {
      res: {
        201: any;
      };
    };
    delete: {
      res: {
        200: any;
      };
    };
  };
  '/api/v1/indicator-routing-queue/configuration': {
    get: {
      res: {
        200: IndicatorRoutingConfiguration;
      };
    };
    patch: {
      req: {
        requestBody: UpdateIndicatorRoutingConfigurationDto;
      };
      res: {
        200: IndicatorRoutingConfiguration;
      };
    };
  };
  '/api/v1/monitoring/{monitoringId}': {
    get: {
      req: {
        monitoringId: string;
      };
      res: {
        200: MonitoringLocationDto;
      };
    };
  };
  '/api/v1/monitoring': {
    post: {
      req: {
        requestBody: CreateMonitoringDto;
      };
      res: {
        201: Monitoring;
      };
    };
  };
  '/api/v1/monitoring/qr': {
    post: {
      req: {
        requestBody: CreateMonitoringDto;
      };
      res: {
        201: Monitoring;
      };
    };
  };
  '/api/v1/monitoring/daily/{monitoringId}': {
    get: {
      req: {
        monitoringId: string;
      };
      res: {
        200: MonitoringLocationDto;
      };
    };
  };
  '/api/v1/monitoring/analysis': {
    post: {
      req: {
        requestBody: AnalyseMonitoringDto;
      };
      res: {
        201: Array<MonitoringAnalysisData>;
      };
    };
  };
  '/api/v1/monitoring/shared-analysis/{sharedAnalysisId}': {
    get: {
      req: {
        sharedAnalysisId: string;
      };
      res: {
        200: Array<MonitoringAnalysisData>;
      };
    };
  };
  '/api/v1/monitoring/public-analysis': {
    post: {
      req: {
        requestBody: PublicAnalyseMonitoringDto;
      };
      res: {
        201: Array<MonitoringAnalysisData>;
      };
    };
  };
  '/api/v1/monitoring/public-analysis/admin-levels': {
    get: {
      res: {
        200: Array<AdminLevel>;
      };
    };
  };
};
